import * as React from "react";
import cx from "classnames";

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes, Intent } from "@blueprintjs/core";
import { Button, Card, Elevation,Icon, Overlay,H4 } from "@blueprintjs/core";
import { Checkbox } from '@material-ui/core';
import  {MSG_VISIO} from "../MessagesVisio.js"
import{HomeProps} from './Home.tsx'
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
    MultistepDialog,
    DialogStep,
    ButtonProps,
    RadioGroup,
    Radio,
    NumericInput,
    Label,
} from "@blueprintjs/core";
import PanelNom from './PanelNom.tsx';
import PanelEmail from './PanelEmail.tsx';
import PanelPassword from './PanelPassword.tsx';
import PanelOnePassword from './PanelOnePassword.tsx';
import MyToaster from './components/MyToaster.tsx';
import { type, userInfo } from "os";
import { throws } from "assert";
import { INTENT_PRIMARY } from "@blueprintjs/core/lib/esm/common/classes";

export type type_home = {
value:undefined,
isValidSignin:undefined,
isValidLogin:undefined
}

export default class CardVisioMagistrale extends React.Component  <{}> {
 // class_selected=Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_SUCCESS;
 // class_noselected=Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING;
  msg_visio=MSG_VISIO;
  state = {
    name: '',
    dcnx:false,
    selected_mesdocuments:false,
    lstStudent:false,
    selected_visio:false,
    selected_reduire:640,
    nb_student:0,
    must_refresh:false,
    selected_student:[{}],
    frameurl:undefined,
    allinvisio:false
  }  
  
  

  constructor(props) {
        super(props);
        
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
    console.log(this.props);
    this.setState({nb_student:this.props.nb_student_cnx})
    var obj=[];
    this.props.datastudent.map((item, idx)=>{
      var item2=item;
      item2.selected=true;
      if(item2.etat=="En ligne") obj.push(item2) 
     });
     this.setState({selected_student:obj});
    //this.handleU();
   
    
  }
 
  componentDidUpdate(prevProps, prevState) {
  //if(this.props.selected_visio!=this.state.selected_visio)this.setState({selected_visio:this.props.selected_visio})
  if(this.props.frameurl!=this.state.frameurl)this.setState({frameurl:this.props.frameurl})
   if(this.props.nb_student_cnx!=this.state.nb_student)
   {
    this.setState({nb_student:this.props.nb_student_cnx})
    var obj=[];
    this.props.datastudent.map((item, idx)=>{
      var item2=item;
      item2.selected=true;
      if(item2.etat=="En ligne") obj.push(item2) 
     });
     this.setState({selected_student:obj});
     
   }
   if(this.state.must_refresh==true) this.setState({must_refresh:false});
    /* if (prevState.name !== prevProps.usernickname.nickname) {
      this.handleUpdateName();
    }*/
  }
  
  showRedirige = (url) => {
    if(url!=undefined)
    {
      console.log("url:"+url)
      //window.location=url;
      const varstyle="style='width:100%;height:800px;display:block;position: absolute;border: 0;z-index:1'";
      return <div style={{width:'100%',height:'100%',display:'block',marginTop:-50, position: 'absolute',border: '0'}}  dangerouslySetInnerHTML={{ __html: "<iframe id='iframe_visio'" +varstyle+"  src='"+url+"' />"}} />;
    }
  
  }
 /* handleUpdateName = () => {
    this.setState({ name: this.props.usernickname.nickname });
    const item=document.getElementById('id_name');
    item.value=this.props.usernickname.nickname;
  }*/
   render() {
    
    const {nom_student,handleOpenVisio,handleSelectPage}=this.props;
    const targetClassName_document = cx({'bp3-outlined':! this.state.selected_mesdocuments}, Classes.LARGE,  {'bp3-intent-success': this.state.selected_mesdocuments} );
    const targetClassName_lstStudent = cx({'bp3-outlined':! this.state.lstStudent}, Classes.LARGE,  {'bp3-intent-success': this.state.lstStudent} );
    const targetClassName_reduire = cx(Classes.OUTLINED, Classes.LARGE,  {'bp3-intent-danger': false} );
    const targetClassName_visio = cx({'bp3-outlined':! this.state.selected_visio}, Classes.LARGE,  {'bp3-intent-success': this.state.selected_visio} );
    return(
     <div style={{position:'relative',zIndex:10,height:840}}>
       <div style={{position:'relative',zIndex:10}}>
        <Card>
            <Button icon="flow-review-branch" intent={!this.state.allinvisio?Intent.PRIMARY:Intent.DANGER} disabled={this.state.nb_student==0} onClick={(ev)=>{ev.preventDefault();if(!this.state.allinvisio){this.setState({allinvisio:true});handleOpenVisio(this.msg_visio.ALL_IN_VISIO,"");handleOpenVisio(this.msg_visio.OUVRIR_VISIO,"");this.setState({selected_visio:true});}else{this.setState({allinvisio:false});handleOpenVisio(this.msg_visio.ALL_OUT_VISIO,"");handleOpenVisio(this.msg_visio.FERMER_VISIO,"");this.setState({selected_visio:false});}}}>{!this.state.allinvisio?"Mettre en Visio Conférence":"Fermer la Visio Conférence"}</Button>
            <Button disabled={this.state.nb_student==0} onClick={(ev)=>{ev.preventDefault();handleOpenVisio(this.msg_visio.OUVRIR_CAMERA,this.state.selected_student);}}>Voir leurs cameras</Button>
            <Button disabled={this.state.nb_student==0} onClick={(ev)=>{ev.preventDefault();handleOpenVisio(this.msg_visio.FERMER_CAMERA,this.state.selected_student);}}>éteindre leurs cameras</Button>
            <Button disabled={this.state.nb_student==0} onClick={(ev)=>{ev.preventDefault();handleOpenVisio(this.msg_visio.OUVRIR_MICROPHONE,this.state.selected_student);}}>Entendre les étudiants</Button>
            <Button disabled={this.state.nb_student==0} onClick={(ev)=>{ev.preventDefault();handleOpenVisio(this.msg_visio.FERMER_MICROPHONE,this.state.selected_student);}}>couper les microphones</Button> 
            <Button  onClick={(ev)=>
              {
                ev.preventDefault();
                if(!this.state.selected_visio)
                {handleOpenVisio(this.msg_visio.OUVRIR_VISIO,"");this.setState({selected_visio:true});}
                else{handleOpenVisio(this.msg_visio.FERMER_VISIO,"");this.setState({selected_visio:false});}
              }}
              className={targetClassName_visio} icon="eye-open" title="Entrez dans la classe"></Button>
               
               {!this.state.allinvisio?<div style={{ color: '#444', background: '#fff', padding: '50px', width: '100%'}}>
              <H4>Liste des étudiants participants à la visio magistrale</H4>
              <ul>
                  {this.state.selected_student.map((item, idx) => (
                    <div style={{height: item.etat=="En ligne"?'20px':'0px'}}>{item ? item.etat=="En ligne"?<span ><span><b>{item.nickname}</b>:  est en ligne</span></span>:null:null}</div>
                  ))}
                </ul></div>:null}
              
            
      </Card>
      </div>
    {this.showRedirige(this.state.frameurl)}
     </div>);
}
}
